import axios from 'axios';

export default (initAction, initAbandoned) => ({
  a: '',
  action: initAction,
  abandonedAction: initAbandoned,
  step: 0,
  steps: 8,
  data: {
    id: 0,
    postal_code: '',
    building_type: '',
    type: [],
    name: '',
    email: '',
    phone: '',
    referal_code: '',
    agree: '',
    bathroom_layout: '',
    vanity_layout: '',
    bathroom_size: '',
    kitchen_like: '',
    concepts: [],
    financing: '',
    address: '',
    timeline: '',
    budget: '',
    hear_us: '',
  },
  stepsValidation: [
    { fields: ['postal_code'], valid: false },
    { fields: ['building_type'], valid: false },
    { fields: ['type'], valid: false },
    { fields: ['name', 'email', 'phone', 'agree'], valid: false },
    { valid: true },
    { fields: ['financing'], valid: false },
    { fields: ['address'], valid: false },
    { fields: ['timeline', 'budget', 'hear_us'], valid: false }
  ],
  validations: {
    postal_code: { mask: /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z]\s?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i, valid: true },
    name: { mask: /.{3,}/, valid: true }, 
    email: { mask: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/, valid: true }, 
    phone: { mask: /^[\+]?[0-9]{10,13}$/im, valid: true },  
    address: { mask: /.{3,}/, valid: true },
  },
  touched: false,
  canAbandon: true,
  sended: false,
  success: false,

  init() {
    window.addEventListener('visibilitychange', () => this.abandon());
    window.addEventListener('pagehide', () => this.abandon());
    window.addEventListener('unload', () => this.abandon());
    window.addEventListener('beforeunload', () => this.abandon());
    // window.addEventListener('blur', () => this.abandon());
    document.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.abandon();
        setTimeout(() => location.href = link.getAttribute('href'), 500);
      })
    });

    this.$watch('step', val => {
      let el = this.$refs.body.children[val];
      
      this.$refs.body.style.transform = `translateY(-${val * 100}%)`;
      this.checkStep();
      window.scrollTo(0,0);
    });

    this.$watch('data.type', val => {
      if (val.length == 1) {
        this.steps = 9;
        this.stepsValidation.splice(5, 0, { valid: true });
      } else {
        this.steps = 8;
        this.stepsValidation.splice(5, 1);
      }
    });
    
    // WATCHING FIELDS
    // let watchable = Object.keys(this.data).map(val => `data.${val}`);
    Object.keys(this.data).forEach(key => {
      this.$watch(`data.${key}`, (val) => {
        this.checkStep();
        this.checkField(key);
      });
    });
  },
  changeField(e) {
    this.data[e.srcElement.getAttribute('name')] = e.srcElement.value;
    
    console.log(this.data);
  },
  checkField(field) {
    let validation = this.validations[field];

    validation.valid = !((validation.mask && this.data[field].match(validation.mask) == null) || this.data[field] == '');
  },
  checkStep(step = this.step) {
    this.touched = true;

    let fields = this.stepsValidation[step].fields,
        valid = true;

    if (fields) {
      for (let field of fields) {
        if ((this.validations[field] && this.data[field].match(this.validations[field].mask) == null) || this.data[field] == '') {
          valid = false;
        }
      }

      this.stepsValidation[step].valid = valid;
    }
  }, 
  prevStep() {
    if (this.step != 0) {
      --this.step;
    }
  },
  nextStep() {
    if (this.step == this.steps - 1) {
      this.submit();
    } else if (this.stepsValidation[this.step].valid) {
      ++this.step;
    }
  },
  onConceptChange(e) {
    this.data.concept_id = e.detail.type;
  },
  submit() {
    this.canAbandon = false;

    if (!this.sended) {
      this.sended = true;
      
      axios.post(this.action, this.data)
        .then(response => {
          this.success = true;
        })
        .catch(response => {
          this.sended = false;
          this.canAbandon = false;
          alert('Something went wrong, please try again or contact us');
        });
    }
  },
  abandon() {
    console.log('abandoned');
    if (this.touched && this.canAbandon) {
      this.canAbandon = false;
      let data = new FormData(document.forms.flow);
      axios.post(this.abandonedAction, this.data)
        .then(response => {
          this.data.id = response.data.id;
        })
        .catch(response => {
          console.log(response);
        })
    }
  }
});